<template>
  <div>
    <div v-if="loading" class="loadingLeftNav">
      <LeftNavSkeleton />
    </div>
    <div v-else-if="isMcom">
      <LeftNav>
        <template #custom-header>
          <li class="grid-x align-middle show-for-large left-nav-link-block">
            <a class="cell large-10 large" href="/myaccount/home" role="heading" aria-level="2">My Account</a>
          </li>
        </template>
      </LeftNav>
    </div>
    <div v-else>
      <LeftNav />
    </div>
  </div>
</template>

<script setup>
import LeftNav from '@nuxt-common/left-nav/app/components/LeftNav.vue';
import LeftNavSkeleton from '~/components/common/skeletons/LeftNavSkeleton.vue';
const { isMcom } = useBrand();

defineProps({
  row: {
    type: Object,
    default() {
      return {};
    },
  },
  loading: {
    type: Boolean,
    default: false,
  },
});
</script>

<style lang="scss" scoped>
@import '~settingSCSS';
</style>
